//
//	Order user part
//
import React, { Component } from 'react';
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faFilter, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const mapStateToProps = state  => {
	return {
		users: state.users,
		usersVisible: state.usersVisible,
		usersTotal: state.usersTotal,
		showItems: state.showItems,
		userOrder: state.userOrder,
		text_top_title: state.text_top_title,
		isMobile: state.isMobile,
	};
};

class UserSort extends Component {

	constructor(props) {

		super(props);
		this.state = {isOpen: false }
		this.handleMenuButton = this.handleMenuButton.bind(this);
		
	}

	//	Order users by specific..
	orderUsers = (event) => {
		this.props.dispatch({type: 'ORDER_USERS', order:event.target.attributes.getNamedItem('data-sort').value});
		this.setState({ isOpen: !this.state.isOpen });
	};

	//	Update input form
	handleMenuButton(event) {
		this.setState({ isOpen: !this.state.isOpen });
	}



	renderFiltersMenuOpened = () => {
		return(
			<div className="filtersContainer">
				<div className="filtersMenu">
					<div className="filtersMenuHead">
						<div className="filtersCloseBtn" onClick={this.handleMenuButton}><FontAwesomeIcon icon={faTimes} /></div>
						<span>FILTER MODELS</span>
						<button className="reset" onClick={this.orderUsers}><FontAwesomeIcon icon={faTrashAlt} /></button> {/*reset needs update*/}
					</div>
					<div className="filterOptions">
						<div className="filter-title">Filter Alphabetically:</div>
						<div className="sort-by">
							<button className="filter" data-sort="AtoZ" onClick={this.orderUsers}>Name A-Z</button>
							<button className="filter" data-sort="ZtoA" onClick={this.orderUsers}>Name Z-A</button>
						</div>
						<div className="filter-title">Filter By Users Preference:</div>
						<div className="sort-by">
							<button className="filter" data-sort="POPULAR" onClick={this.orderUsers}>Popular</button>
							<button className="filter" data-sort="USERS"onClick={this.orderUsers}>Chatters</button>
						</div>
						<div className="filter-title">Filter By Online Time:</div>
						<div className="sort-by">
							<button className="filter" data-sort="OLDEST" onClick={this.orderUsers}>Oldest</button>
							<button className="filter" data-sort="YOUNGEST" onClick={this.orderUsers}>Youngest</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderFiltersMenuClosed = () => {
		return(
			<div className="filtersContainer">
				<div className="topBox">
					<button className="open-filters-btn" onClick={this.handleMenuButton}>Filters <FontAwesomeIcon icon={faFilter} /></button>
					<div className="page-title">{this.props.text_top_title}</div>
				</div>
			</div>
		);
	}
			
	render() {

		if( this.props.isMobile ) {
			return (
				<div>
					{this.state.isOpen ?  this.renderFiltersMenuOpened() : this.renderFiltersMenuClosed()}
				</div>
			)
		} else {
			return (
				<div className="topbar-desktop">
					<div>{this.props.text_top_title}</div>
					<div className="filter-desktop">
						<span>FILTERS:</span>
						<button className="filter-desktop-btn" data-sort="AtoZ" onClick={this.orderUsers}>Name A-Z</button>
						<button className="filter-desktop-btn" data-sort="ZtoA" onClick={this.orderUsers}>Name Z-A</button>
						<button className="filter-desktop-btn" data-sort="POPULAR" onClick={this.orderUsers}>Popular</button>
						<button className="filter-desktop-btn" data-sort="USERS"onClick={this.orderUsers}>Chatters</button>
						<button className="filter-desktop-btn" data-sort="OLDEST" onClick={this.orderUsers}>Oldest</button>
						<button className="filter-desktop-btn" data-sort="YOUNGEST" onClick={this.orderUsers}>Youngest</button>
					</div>
				</div>
			)
		}
	}
}

export default connect(mapStateToProps)(UserSort);


// WEBPACK FOOTER //
// ./src/components/parts/UserSort.js